
import Vue from 'vue';
import TeaserItem from '~/components/base/TeaserItem/TeaserItem.vue';
import { TransformedTmGrid } from '~/transforms/transformModules';

export default Vue.extend({
  components: { TeaserItem },
  props: {
    data: {
      type: Object as () => TransformedTmGrid['data'],
      required: true,
    },
  },
});
